export const pointsHistoryReasons = [
  { value: 0, label: "Unknown" },
  { value: 1, label: "Use" },
  { value: 2, label: "Reselling" },
  { value: 3, label: "Promo" },
  { value: 4, label: "Manual" },
  { value: 5, label: "Season Clear" },
]